import { Role } from "../@types/Role";

export const isAdminForCommunity = (
  roles: Role[],
  communityUniqId: string,
): boolean => {
  return !!roles.filter((role) => {
    return role.communityUniqId === communityUniqId && role.role === "admin";
  }).length;
};
